export const COLORS = {
  primary: '#470912',       // Deep dark maroon
  primaryHover: '#621725',  // Lighter maroon for hover states
  secondary: '#FFFCF3',     // Warm white — main text & button color
  secondaryHover: '#e8e4d8',// Dimmed warm white for hover states
  accent: '#CAA96D',        // Sand gold — decorative highlights, focus borders
  error: '#FFD2D2',         // Light red for errors
  cream: '#F5F0E8',         // Cream for card backgrounds
  black: '#080303',         // Near black
} as const;

export type ColorKey = keyof typeof COLORS;
